import { writable } from "svelte/store";
import { browser } from "$app/environment";
import { setAnalyticsConsent } from "$lib/utils/analytics";

export type AnalyticsConsent = "granted" | "denied";

// Bump this if the notice's substance changes so every visitor chooses again.
const STORAGE_KEY = "pc_cookie_consent_v2";

function readConsent(): AnalyticsConsent | null {
   if (!browser) return "denied"; // never render during SSR
   try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === "granted" || stored === "denied" ? stored : null;
   } catch {
      // localStorage can throw in locked-down/private-browsing contexts.
      return "denied";
   }
}

const { subscribe, set } = writable<AnalyticsConsent | null>(readConsent());

/**
 * The visitor's analytics choice for this browser: "granted", "denied", or
 * null while undecided. `choose` stores it and applies it to PostHog; `clear`
 * forgets it so the cookie notice is shown again.
 */
export const analyticsConsent = {
   subscribe,
   choose: (choice: AnalyticsConsent) => {
      if (browser) {
         try {
            localStorage.setItem(STORAGE_KEY, choice);
         } catch {
            // Ignore — worst case the notice reappears next visit.
         }
      }
      set(choice);
      setAnalyticsConsent(choice === "granted");
   },
   clear: () => {
      if (browser) {
         try {
            localStorage.removeItem(STORAGE_KEY);
         } catch {
            // Ignore.
         }
      }
      set(null);
   },
};
